import { ModalContext } from 'App';
import CmsContext from 'CmsContext';
import React, { useEffect, useContext, useState } from 'react';
import useFormValidator from 'useFormValidator';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import InputPassword from 'modules/common/components/InputPassword';
import APP_VERSION from 'version';
import PropTypes from 'prop-types';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import Modal from 'modules/common/components/Modal';
import _, { isEmpty } from 'lodash';
import * as c from 'modules/auth/constants';
import * as actions from 'modules/auth/actions';
import { connect } from 'react-redux';
import { set, getJson, get, removeItem } from 'session';
import { withRouter } from 'react-router-dom';
import styles from './LogInModal.module.css';
/* eslint-disable import/no-cycle */
import SignUpPinModal from './SignUpPinModal';
import LoginContainerModal from './LoginContainerModal';

const INIT_STATE = {
  email: '',
  password: '',
  password_confirmation: '',
  mobile_number: '',
  last_name: '',
  first_name: '',
  birth_date: '',
  captcha: '',
  is_resident: 0,
  data_privacy: 0,
};

const useEmailStyle = {
  cursor: 'pointer',
  textDecoration: 'underline',
  color: '#007bff',
  fontSize: '12px',
};

const getMaxDate = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 15);
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
    today.getDate()
  ).padStart(2, '0')}`;
};

const SignUpModalNew = ({ isLoading, register }) => {
  const cmsContext = useContext(CmsContext);
  const LOGOS = cmsContext.findByType('LOGOS');
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(INIT_STATE);
  const [isEmail, setIsEmail] = useState(false);
  const [isAgreeTerms, setIsAgreeTerms] = useState(false);
  const formValidator = useFormValidator(formData, {
    first_name: 'required|text_vapt',
    last_name: 'required|text_vapt',
    password: 'required|password',
    birth_date: 'required',
    password_confirmation: 'required|match:password',
  });

  useEffect(() => {
    const signupFormData = getJson('signupFormData');
    if (!isEmpty(signupFormData)) {
      setFormData(signupFormData);
      setIsEmail(Boolean(signupFormData.email));
    }
    return () => {
      setFormData(INIT_STATE);
    };
  }, []);

  useEffect(() => {
    const common = {
      first_name: 'required|text_vapt',
      last_name: 'required|text_vapt',
      password: 'required|password',
      birth_date: 'required',
      password_confirmation: 'required|match:password',
    };
    if (isEmail) {
      formValidator.onSetObjectRules({
        ...common,
        email: 'required|email',
      });
      return;
    }

    formValidator.onSetObjectRules({
      ...common,
      mobile_number: 'required|mobile_number_63',
    });
  }, [isEmail]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleUseEmail = () => {
    if (isEmail) {
      setFormData((prev) => ({
        ...prev,
        email: '',
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        mobile_number: '',
      }));
    }
    setIsEmail(!isEmail);
  };
  const handleOnClose = () => setModal({ isOpen: false });
  const toggleIsAgreeTerms = () => setIsAgreeTerms(!isAgreeTerms);

  const handleOpenAuthModal = () => {
    setModal({
      isOpen: true,
      content: <LoginContainerModal />,
      title: null,
      modalSize: 'modal-login',
      hideHeader: true,
      isCentered: true,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const storageForm = get('signupFormData');
    if (JSON.stringify(formData) !== storageForm) {
      removeItem('cd');
    }
    set('signupFormData', JSON.stringify(formData));

    register(
      formData,
      () => {
        setModal({
          isOpen: true,
          content: <SignUpPinModal />,
          title: null,
          modalSize: 'modal-login',
          hideHeader: true,
          isCentered: true,
        });
      },
      (cb) => {
        if (cb?.response?.redirect_to_form) {
          setModal({
            isOpen: true,
            content: <SignUpPinModal remainingTime={cb.response.redirect_to_form} />,
            title: null,
            modalSize: 'modal-login',
            hideHeader: true,
            isCentered: true,
          });
        }
      }
    );
  };

  return (
    <Modal.Body>
      <div className='d-flex flex-column w-full p-3'>
        <div className='d-flex justify-content-between align-items-start'>
          <img
            className='relative'
            src={
              _.get(LOGOS, 'MAIN_LOGO.cdnUrl', '') || _.get(LOGOS, 'MAIN_LOGO', '') || defaultPhoto
            }
            alt=''
            width={120}
            height={35}
          />
          <button type='button' className='close modal-close float-right' onClick={handleOnClose}>
            <span aria-hidden='true'>&times;</span>
          </button>
        </div>

        <div className={`${styles['login-welcome']} my-1`}>Welcome!</div>
        <div className={styles['login-description']}>Create your account</div>

        <form defaultValue={formData} onSubmit={handleSubmit} className='mt-3'>
          <div className='form-group'>
            <label htmlFor='first_name' className={styles['login-form-label-text']}>
              First Name {formValidator.renderMessage('first_name')}
            </label>
            <input
              className='form-control text-uppercase'
              type='text'
              name='first_name'
              id='first_name'
              onChange={handleOnChange}
              value={formData.first_name}
              placeholder='ex. Juan'
              autoComplete='off'
              required
              autoFocus
            />
          </div>
          <div className='form-group'>
            <label htmlFor='last_name' className={styles['login-form-label-text']}>
              Last Name {formValidator.renderMessage('last_name')}
            </label>
            <input
              className='form-control text-uppercase'
              type='text'
              name='last_name'
              id='last_name'
              onChange={handleOnChange}
              value={formData.last_name}
              placeholder='ex. Dela Cruz'
              autoComplete='off'
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='birth_date' className={styles['login-form-label-text']}>
              Birth Date {formValidator.renderMessage('birth_date')}
            </label>
            <input
              className='form-control text-uppercase'
              type='date'
              name='birth_date'
              id='birth_date'
              onChange={handleOnChange}
              value={formData.birth_date}
              autoComplete='off'
              required
              max={getMaxDate()}
            />
          </div>
          {isEmail ? (
            <div className='form-group'>
              <label
                htmlFor='email'
                className={`${styles['login-form-label-text']} d-flex align-items-center justify-content-between`}
              >
                <span>Email {formValidator.renderMessage('email')}</span>
                <span
                  role='button'
                  tabIndex='0'
                  style={useEmailStyle}
                  onClick={toggleUseEmail}
                  onKeyDown={() => {}}
                >
                  Use Mobile Number
                </span>
              </label>
              <input
                className='form-control'
                type='email'
                name='email'
                id='email'
                onChange={handleOnChange}
                value={formData.email}
                placeholder='ex. sample@email.com'
                autoComplete='off'
                required
              />
            </div>
          ) : (
            <div className='form-group'>
              <label
                htmlFor='mobile_number'
                className={`${styles['login-form-label-text']} d-flex align-items-center justify-content-between`}
              >
                <span>Mobile Number {formValidator.renderMessage('mobile_number')}</span>
                <span
                  role='button'
                  tabIndex='0'
                  style={useEmailStyle}
                  onClick={toggleUseEmail}
                  onKeyDown={() => {}}
                >
                  Use Email
                </span>
              </label>
              <FormInputMobile
                autoComplete='off'
                type='tel'
                name='mobile_number'
                onChange={setFormData}
                value={formData.mobile_number}
              />
            </div>
          )}
          <div className='form-group'>
            <label htmlFor='password' className={styles['login-form-label-text']}>
              Password {formValidator.renderMessage('password')}
            </label>
            <InputPassword
              name='password'
              onChange={handleOnChange}
              value={formData.password}
              id='password'
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='password_confirmation' className={styles['login-form-label-text']}>
              Confirm Password {formValidator.renderMessage('password_confirmation')}
            </label>
            <InputPassword
              name='password_confirmation'
              onChange={handleOnChange}
              value={formData.password_confirmation}
              id='password_confirmation'
              required
              aria-describedby='passwordHelp'
            />
            <small
              id='passwordHelp'
              className={`${styles['login-form-label-text']} form-text text-muted`}
            >
              Password must have minimum of 12 characters, 1 uppercase, 1 lowercase, 1 symbol, and 1
              number
            </small>
          </div>
          <div className='form-group form-check'>
            <input
              type='checkbox'
              className='form-check-input'
              id='terms'
              onChange={toggleIsAgreeTerms}
            />
            <label className={styles['login-form-label-text']} htmlFor='terms'>
              I agree with the eLGU Privacy Notice and giving consent to the collection and
              processing of my personal data in accordance thereto.
            </label>
          </div>

          <button
            type='submit'
            disabled={isLoading || !formValidator.response.is_passed || !isAgreeTerms}
            className='w-full inline-block text-center rounded-md bg-slate-800 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600 border border-slate-900'
          >
            {isLoading && <i className='fa fa-spin fa-spinner' />} Sign up
          </button>

          <p className='text-xs text-center w-full mt-3'>{APP_VERSION}</p>

          <div
            className={styles['login-signup-here']}
            role='button'
            tabIndex='0'
            onClick={handleOpenAuthModal}
            onKeyDown={() => {}}
          >
            Already have an account? <b>Log in Here.</b>
          </div>
        </form>
      </div>
    </Modal.Body>
  );
};

SignUpModalNew.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  register: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, 'loading', []).indexOf(c.REGISTER) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SignUpModalNew);
